var _path, _path2, _path3, _path4, _path5, _path6, _path7, _ellipse, _ellipse2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTnfd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0537 21.0046C17.5123 20.214 20.213 17.5133 21.0036 14.0547",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.99609 9.94599C3.78672 6.48742 6.48742 3.78672 9.94599 2.99609",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.94599 21.0046C6.48742 20.214 3.78672 17.5133 2.99609 14.0547",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.94599 2.99609C6.48742 3.78672 3.78672 6.48742 2.99609 9.94599",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0036 14.0547C20.213 17.5133 17.5123 20.214 14.0537 21.0046",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0537 2.99609C17.5123 3.78672 20.213 6.48742 21.0036 9.94599",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0502 12.0022C12.0491 12.0295 12.0263 12.0509 11.9989 12.0502C11.9716 12.0495 11.9499 12.0269 11.9502 11.9996C11.9506 11.9722 11.9728 11.9502 12.0002 11.9502C12.0137 11.9505 12.0266 11.9561 12.036 11.9658C12.0454 11.9756 12.0505 11.9887 12.0502 12.0022",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 12.0002,
    rx: 3.04927,
    ry: 6.38066,
    transform: "rotate(-45 12 12.0002)",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 11.9998,
    rx: 6.38066,
    ry: 3.04927,
    transform: "rotate(-45 12 11.9998)",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTnfd);
export default __webpack_public_path__ + "static/media/tnfd.bf368608619f07a275ed29f9b8f68432.svg";
export { ForwardRef as ReactComponent };